import {
  type Color,
  getColorDisplayName,
} from "@cloudnest/augmented-chess-engine";

interface GameInfoBarProps {
  currentPlayer: Color;
  turnNumber: number;
  isInCheck: boolean;
  isMyTurn?: boolean;
}

export function GameInfoBar({
  currentPlayer,
  turnNumber,
  isInCheck,
  isMyTurn,
}: GameInfoBarProps): JSX.Element {
  return (
    <div className="mb-3 flex flex-wrap justify-center gap-3 rounded-lg bg-white/95 px-3 py-2 text-gray-900 text-xs shadow-lg backdrop-blur-sm sm:mb-4 sm:gap-6 sm:px-6 sm:py-3 sm:text-sm">
      <div>
        <strong>{"\uCC28\uB840:"}</strong>{" "}
        <span
          data-testid="turn-indicator"
          className={`font-semibold ${
            isMyTurn === true
              ? "text-green-600"
              : isMyTurn === false
                ? "text-gray-600"
                : "text-gray-900"
          }`}
        >
          {getColorDisplayName(currentPlayer)}
          {isMyTurn === true ? " (\uB0B4 \uCC28\uB840)" : ""}
        </span>
      </div>
      <div>
        <strong>{"\uC218:"}</strong>{" "}
        <span data-testid="move-number">{turnNumber}</span>
      </div>
      {isInCheck && (
        <div className="font-semibold text-red-700">{"\uCCB4\uD06C!"}</div>
      )}
    </div>
  );
}
